const branding = {
  pageTitle: "CredIssuer",
  referenceIdLabel: "Reference ID on CredIssuer",
  verificationMark: null,
  portalBanner: null,
  portalBannerMobile: null,
  credentialInfoImage: null,
  overlayHeroCopy: false,
  preferLocalHeroBanners: false,
  contact: {
    email: "support@credissuer.com",
    phone: "",
    address: "",
  },
};

export default branding;
